import * as svg from "../../../assets/battery.svg";

import {iconBuilder} from "./iconBuilder";

export const BatteryIcon = iconBuilder(svg, "BatteryIcon", "0 0 24 24");
